
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","stroke":"currentColor","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M441.6.158C372.83 3.53 320 62.858 320 131.657V224H64c-35.35 0-64 28.7-64 64v160c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V288c0-35.35-28.65-64-64-64h-48v-92.75c0-60.23 46.18-112.1 106.3-115.1C506.7 12.96 560 64.37 560 128v88c0 4.4 3.6 8 8 8s8-3.6 8-8v-88C576 55.3 515.1-3.447 441.6.157zM384 240c26.47 0 48 21.53 48 48v160c0 26.47-21.53 48-48 48H64c-26.47 0-48-21.53-48-48V288c0-26.47 21.53-48 48-48h320z"}})])
          )
        }
      }
    